import core from './core';

export default {
  get({ search, page, per_page, sort, direction }) {
    return core.get('issues', {
      params: {
        search, page, per_page, sort, direction
      }
    });
  },
}
